import Navbar from "components/Navbar"
import React from "react";
import Footer from "components/Footer";
import { useSelector } from "react-redux";
import MobileNavbar from "components/MobileNavbar";
import MobileFooter from "components/MobileFooter";
import ProgramAll from "components/Program/ProgramAll";

function Program () {

    const isMobile = useSelector(state => state.windowSize.isMobile);

    return(
        <>
        {isMobile ? (
            <>
            <MobileNavbar />
            <ProgramAll />
            <MobileFooter />
            </>
        ) : (
            <>
            <Navbar />
            <ProgramAll />
            <Footer />
            </>
        )}
        </>
    )
}

export default Program